/*
 * This code is based on an implementation provided by Luke Edwards
 * [https://github.com/lukeed/dequal]
 * Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 * release v2.0.3
 */


const has = Object.prototype.hasOwnProperty;

export function dequalLite(foo, bar) {
	let ctor, len;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequalLite(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequalLite(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}